import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-16 mb-12">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold text-white">Avant-Garde</span>
              <span className="block text-xs font-medium uppercase tracking-widest text-white/60">Consulting</span>
            </Link>
            <p className="text-white/70 text-sm leading-relaxed mb-6">
              Fractional CRO & CSO services for tech startups. Scale your revenue without breaking the bank.
            </p>
            <div className="flex gap-3">
              <a href="mailto:sameerpant@avant-gardeconsulting.co.in" className="w-9 h-9 rounded-lg bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-gradient transition-colors" aria-label="Email">
                <Mail className="w-4 h-4" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-gradient transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg bg-white/10 border border-white/20 flex items-center justify-center text-white hover:bg-gradient transition-colors" aria-label="Twitter">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-2.5">
              <li><Link to="/services/revscale" className="text-sm text-white/60 hover:text-white transition-colors">RevScale Fractional CSO/CRO</Link></li>
              <li><Link to="/services/leadership-hiring" className="text-sm text-white/60 hover:text-white transition-colors">Leadership Hiring</Link></li>
              <li><Link to="/services/product-roadmapping" className="text-sm text-white/60 hover:text-white transition-colors">Product Roadmapping</Link></li>
              <li><Link to="/services/corporate-golf" className="text-sm text-white/60 hover:text-white transition-colors">Golf for Corporate Success</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li><Link to="/why-fractional" className="text-sm text-white/60 hover:text-white transition-colors">Why Us</Link></li>
              <li><Link to="/roi-calculator" className="text-sm text-white/60 hover:text-white transition-colors">ROI Calculator</Link></li>
              <li><Link to="/testimonials" className="text-sm text-white/60 hover:text-white transition-colors">Testimonials</Link></li>
              <li><Link to="/faq" className="text-sm text-white/60 hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Resources</h4>
            <ul className="space-y-2.5">
              <li><Link to="/contact" className="text-sm text-white/60 hover:text-white transition-colors">Contact Us</Link></li>
              <li><a href="#" className="text-sm text-white/60 hover:text-white transition-colors">Case Studies</a></li>
              <li><a href="#" className="text-sm text-white/60 hover:text-white transition-colors">Blog</a></li>
              <li><a href="#" className="text-sm text-white/60 hover:text-white transition-colors">Startup Resources</a></li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-white/15">
          <div>
            <p className="text-xs text-white/50">
              &copy; {currentYear} Avant-Garde Consulting. All rights reserved.
            </p>
            <p className="text-xs text-white/40 mt-1">
              GSTN: 29ALDPP3353P1ZH
            </p>
          </div>
          <div className="flex gap-4 mt-4 sm:mt-0">
            <a href="#" className="text-xs text-white/50 hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="text-xs text-white/50 hover:text-white transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
